(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-media-gallery"] && !Shopify.designMode) return;
  try {
    // Survol sur ordinateur (23/10/2026) : la 2e photo des cartes visibles est préchargée,
  // pour s'afficher sans délai quand la souris passe sur la carte (règles dans base.css)
  (function () {
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 751px)').matches || !('IntersectionObserver' in window)) return;
    var vue = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (entree) {
        if (!entree.isIntersecting) return;
        var photo = entree.target.querySelectorAll('.splide__slide img')[1];
        if (photo) photo.loading = 'eager';
        vue.unobserve(entree.target);
      });
    }, { rootMargin: '300px' });
    var prevu = false;
    var suivre = function () {
      prevu = false;
      document.querySelectorAll('product-card-media-gallery:not([data-survol])').forEach(function (galerie) {
        galerie.setAttribute('data-survol', '');
        vue.observe(galerie);
      });
    };
    var demarrer = function () {
      suivre();
      new MutationObserver(function () {
        if (!prevu) { prevu = true; requestAnimationFrame(suivre); }
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  })();
  } catch(e) { console.error(e); }
})();

})();
